import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  class: "menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold py-4 fs-6 w-275px",
  "data-kt-menu": "true"
}
const _hoisted_2 = { class: "menu-item px-3" }
const _hoisted_3 = { class: "menu-content d-flex align-items-center px-3" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "symbol symbol-50px me-5" }, [
  /*#__PURE__*/_createElementVNode("img", {
    alt: "Logo",
    src: "media/avatars/300-1.jpg"
  })
], -1)
const _hoisted_5 = {
  key: 1,
  class: "symbol symbol-50px me-5"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  alt: "Logo",
  src: "/media/avatars/blank.png"
}, null, -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "d-flex flex-column" }
const _hoisted_9 = { class: "fw-bolder d-flex align-items-center fs-5" }
const _hoisted_10 = { class: "badge badge-light-info fw-bolder fs-8 px-2 py-1 ms-2" }
const _hoisted_11 = {
  href: "#",
  class: "fw-bold text-muted text-hover-primary fs-7"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "separator my-2" }, null, -1)
const _hoisted_13 = {
  style: {"display":"none"},
  class: "menu-item px-5"
}
const _hoisted_14 = {
  class: "menu-item px-5 d-none",
  "data-kt-menu-trigger": "hover",
  "data-kt-menu-placement": "left-start",
  "data-kt-menu-flip": "center, top"
}
const _hoisted_15 = { class: "menu-title position-relative" }
const _hoisted_16 = { class: "fs-8 rounded bg-light px-3 py-2 position-absolute translate-middle-y top-50 end-0" }
const _hoisted_17 = ["src"]
const _hoisted_18 = { class: "menu-sub menu-sub-dropdown w-175px py-4" }
const _hoisted_19 = { class: "menu-item px-3" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", { class: "symbol symbol-20px me-4" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "rounded-1",
    src: "/media/flags/united-states.svg",
    alt: "metronic"
  })
], -1)
const _hoisted_21 = { class: "menu-item px-3" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", { class: "symbol symbol-20px me-4" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "rounded-1",
    src: "/media/flags/kuwait.svg",
    alt: "metronic"
  })
], -1)
const _hoisted_23 = { class: "menu-item px-5" }

export function render(_ctx: any,_cache: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.user.userType === 'trainer')
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              to: "/manage/members/profile"
            }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            }))
          : (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7)),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createTextVNode(_toDisplayString(_ctx.user.name) + " ", 1),
            _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.user.role?.name), 1)
          ]),
          _createElementVNode("a", _hoisted_11, _toDisplayString(_ctx.user.email.length > 20
                ? _ctx.user.email.slice(0, 18).concat('...')
                : _ctx.user.email), 1)
        ])
      ])
    ]),
    _hoisted_12,
    _createElementVNode("div", _hoisted_13, [
      _createVNode(_component_router_link, {
        to: '/',
        class: "menu-link px-5"
      }, {
        default: _withCtx(() => [
          _createTextVNode(" My Profile ")
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createVNode(_component_router_link, {
        to: "/pages/profile/overview",
        class: "menu-link px-5"
      }, {
        default: _withCtx(() => [
          _createElementVNode("span", _hoisted_15, [
            _createTextVNode(" Language "),
            _createElementVNode("span", _hoisted_16, [
              _createTextVNode(_toDisplayString(_ctx.currentLangugeLocale.name) + " ", 1),
              _createElementVNode("img", {
                class: "w-15px h-15px rounded-1 ms-2",
                src: _ctx.currentLangugeLocale.flag,
                alt: "metronic"
              }, null, 8, _hoisted_17)
            ])
          ])
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("a", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setLang('en'))),
            href: "#",
            class: _normalizeClass(["menu-link d-flex px-5", { active: _ctx.currentLanguage('en') }])
          }, [
            _hoisted_20,
            _createTextVNode(" English ")
          ], 2)
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("a", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setLang('ar'))),
            href: "#",
            class: _normalizeClass(["menu-link d-flex px-5", { active: _ctx.currentLanguage('ar') }])
          }, [
            _hoisted_22,
            _createTextVNode(" العربية ")
          ], 2)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_23, [
      _createElementVNode("a", {
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.signOut())),
        class: "menu-link px-5"
      }, " Sign Out ")
    ])
  ]))
}